<app-side-menu (toggle)="toggleCollapse($event)"></app-side-menu>

<head>

  <link rel="stylesheet" href="admin-hub.component.css">

</head>

<body class="green lighten-5" style=" margin:0; min-height: 800px;">
  <div class="navbar" [class.admin-expanded]="isNavbarExpanded">
    <app-navbar></app-navbar>
  </div>

  <div class="main-panel" [class.admin-expanded]="isNavbarExpanded">
    <br>
    <br>
    <br>
    <br>
    <div class="blue-grey lighten-5">
      <div class="row white" style="border-radius: 20px 20px 0 0;">
        <div class="col s12" style="padding-left: 50px;">
          <h2>{{title}}</h2>
        </div>
        <ul class="tabs">
          <li class="tab col s6" (click)="activeTab='tab1'" [ngClass]="{'active': activeTab === 'tab1'}"><a>Configure
              Pages</a></li>
          <li class="tab col s6" (click)="activeTab='tab2'; loadAuditLog()" [ngClass]="{'active': activeTab === 'tab2'}"><a>Audit
              Log</a></li>
        </ul>

        <div *ngIf="activeTab === 'tab1'" style="padding: 30px;">
          <form>
            <!-- <div class="row">
              <div class="col">
                <div id="test1" class="col s12" style="padding-bottom: 10px">
                  <h1>Page Configurations ⚙️ </h1>
                  <h6 style="margin-left: 0px; color: #838383;"><i>Don't forget to save your changes!</i></h6>
                </div>
              </div>
              <div class="col right">
                <button class="button button1" type="submit"  (click)="onPageSubmit()"><i class="material-icons save-icon">save</i> Save</button>
              </div>
            </div> -->

            <div id="snackbar"></div>

            <div *ngIf="isSuperAdminRole(currUser?.role)" class="config-section">
              <h5 class="config-title">Manage Submissions</h5>
              <p class="config-description">
                When restricted, new vendors cannot start registration on the public portal. Existing users can still sign in with LOGIN.
              </p>
              <p *ngIf="settingsLoading" class="config-status">Loading submission settings…</p>
              <p *ngIf="!settingsLoading" class="config-status">
                Status:
                <strong>{{ submissionsRestricted ? 'Submissions closed' : 'Submissions open' }}</strong>
              </p>
              <button
                type="button"
                class="question-button config-toggle-btn"
                [disabled]="settingsLoading || settingsSaving"
                (click)="toggleSubmissionsRestriction()">
                {{ submissionsRestricted ? 'Allow Submissions' : 'Restrict Submissions' }}
              </button>
            </div>

            <h6 style="color: gray; font-size: 12px; margin-bottom: 0px;">Modify responses for existing Frequently Asked Questions, or create 
              new questions and answers for vendors to view on the <a href="/faq" style="color: rgb(0, 153, 255);">FAQ Page. </a>  </h6>
            <h6 style="color: gray; font-size: 12px; padding-top: 0px;">NOTE: Don't forget to save changes for them to reflect.</h6>

            <ul>
              <li>
                <div class="collapsible-header" > <!-- (click)="toggleCollapsible($event)" -->
                  <i class="material-icons">help_outline</i>
                  FAQ & Support
                </div>
                <div *ngIf="loading" class="spinner-wrapper">
                  <div class="spinner"></div>
                </div>
                <div *ngIf="!loading" class="collapsible-body open"> <!-- Remove "open" if using toggleCollapsible() again-->
                  <div *ngIf="!creatingQuestion">
                    <select style="display: inline-block; margin-bottom: 3%;" [(ngModel)]="selectedQuestion"
                      [ngModelOptions]="{standalone: true}" (ngModelChange)="onQuestionChange($event)">
                      <option [ngValue]="null" disabled>Select Question</option>
                      <option *ngFor="let faq of faqItems; let i = index" [ngValue]="faq">
                        {{ faq.strQuestion }}
                      </option>
                    </select>
                    
                    <textarea *ngIf="selectedQuestion" class="card" id="faq-textarea"
                      [(ngModel)]="selectedQuestion.strAnswer" [ngModelOptions]="{ standalone: true }" rows="4"
                      style="width: 100%; height: 15%; border-radius: 8px; border: 1px solid #ccc; padding: 8px; box-shadow: none;"
                      (ngModelChange)="onFaqChange()">
                    </textarea>
                  </div>

                  <a class="question-button-link" (click)="createQuestion()">{{ createButton }}</a>
                  
                  <button *ngIf="!hideBtn" style="float:right" class="question-button" (click)="onPageSubmit()">Save Changes</button>

                  <!--CREATE QUESTION SECTION-->
                  <div *ngIf="creatingQuestion">
                    <label class="label" id="">New Question: </label>
                    <input input type="text" [id]="" [(ngModel)]="newFaqItem.strQuestion"
                      [ngModelOptions]="{standalone:true}">
                    <br>
                    <label class="label" id="">Response: </label>
                    <textarea input type="text" [id]="" [(ngModel)]="newFaqItem.strAnswer"
                      [ngModelOptions]="{standalone:true}" rows="4" class="card"
                      style="width: 100%; height: 15%; border-radius: 8px; border: 1px solid #ccc; padding: 8px; box-shadow: none;"></textarea>
                    <button class="question-button right" (click)="saveFAQ()">Save</button>
                  </div>
                </div>
              </li>
            </ul>
          </form>
        </div>
        <div *ngIf="activeTab === 'tab2'" style="padding: 30px;">
          <div id="test1" class="col s12" style="padding-bottom: 10px">
            <!-- <h1>Audit Log 🧑‍💼</h1> -->
          </div>

          <div style="position: relative;">
            <table style="background-color: white;">
              <tr>
                <th>Date</th>
                <th>User</th>
                <th>
                  <div style="position: relative; display: inline-block;">
                    <a
                      class="btn-style"
                      href="#"
                      (click)="toggleDropdown($event)"
                    >
                      {{ selectedActivity || 'All Activity' }}
                      <i class="tiny icon-inline material-icons right">keyboard_arrow_down</i>
                    </a>
                
                    <!-- Moved dropdown inside the same container -->
                    <ul id="activityDropdown" class="dropdown-content" [class.dropdown-visible]="sortVisible">
                      <li><a (click)="filterByActivity('', $event)">All Activity</a></li>
                      <li><a (click)="filterByActivity('Approved', $event)">Approved</a></li>
                      <li><a (click)="filterByActivity('Declined', $event)">Declined</a></li>
                      <li><a (click)="filterByActivity('Sent Back', $event)">Sent Back</a></li>
                      <li><a (click)="filterByActivity('Flags', $event)">Flags</a></li>
                      <li><a (click)="filterByActivity('Notes', $event)">Notes</a></li>
                      <li><a (click)="filterByActivity('FAQ', $event)">FAQ</a></li>
                    </ul>
                  </div>
                </th>
                
              </tr>

              <div *ngIf="loading" class="spinner-wrapper">
                <div class="spinner"></div>
              </div>

            <tr *ngFor="let log of auditLog">
              <td>{{ formatDate(log.createdAt) }}</td>
              <td>{{ getUserName(log.adminId) }}</td>
              <td>{{log.activity}}</td>
            </tr>
          </table>
        </div>
         

        </div>

      </div>
    </div>
  </div>
</body>

<script src="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/js/materialize.min.js"></script>